<div
  class="header ion-no-border ion-hide-lg-up"
  [ngClass]="{'ion-hide-lg-up': hideForLg()}"
  >
  <ion-toolbar fixed>
  <div class="main-header" [ngClass]="{'ion-hide': !(loggedIn$ | async)}">
    <div class="main-header-row">
      <!-- Back Button Section -->
      @if (backButton()) {
        <div class="back-section">
          <ion-buttons slot="start">
            <ion-back-button color="primary" text="" defaultHref="/" />
          </ion-buttons>
        </div>
      }
      <!-- Brand Section -->
      <div class="brand-section" [ngClass]="{'with-back-button': backButton()}">
        <img
          src="assets/images/berger3.0_full-128.png"
          alt="Logo"
          class="ion-hide-lg-down brand-logo"
          />
        @if (!(contractService.contractAgreementRequired$ | async) && !auth.hasNoCustomClaims((auth.customClaims$ | async))) {
          <span class="context-divider ion-hide-lg-down" [ngClass]="{'ion-hide': !(loggedIn$ | async)}"></span>
          <div class="context-tabs" [ngClass]="{'ion-hide': !(loggedIn$ | async)}">
            <a
              class="context-tab"
              [class.active]="!isAdminContext"
              (click)="switchContext('bpa')">
              BPA
            </a>
            <a
              class="context-tab"
              [class.active]="isAdminContext"
              (click)="switchContext('admin')">
              Admin
            </a>
          </div>
        }
        @if (!title && !navigationService.hideArtistName) {
          <span class="brand-name">
            {{ payeeName$ | async }}
          </span>
        }
        @if (title) {
          <span class="brand-name">
            {{ title }}
          </span>
        }
      </div>
      <!-- Navigation Section -->
      @if (!(contractService.contractAgreementRequired$ | async)) {
        <div class="menu-context-section" [ngClass]="{'no-user-section': isAdminContext}">
          @if (!isAdminContext) {
            <nav class="nav-section">
              @if (!(payeeService.signedInPayee$ | async)?.internalProperties?.publishingOnly) {
                <a routerLink="/pages/dashboard" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Painel</a>
              }
              <a routerLink="/pages/earnings" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Recebimentos</a>
              <a routerLink="/pages/support" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Suporte</a>
            </nav>
          } @else {
            <nav class="nav-section">
              @if (auth.hasAnyCustomClaims((auth.customClaims$ | async), ['finance'])) {
                <a routerLink="/pages/admin/invoices" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Pagamentos</a>
              }
              <a routerLink="/pages/admin/payees-management" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Beneficiários</a>
              <a routerLink="/pages/admin/compositions-management" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Composições</a>
              @if (auth.hasAnyCustomClaims((auth.customClaims$ | async), ['finance'])) {
                <a routerLink="/pages/admin/publishing-royalties" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: false }">Processamentos Autorais</a>
              }
              @if (auth.hasAnyCustomClaims((auth.customClaims$ | async), ['finance'])) {
                <a routerLink="/pages/admin/admin-reports" [class.active]="isManagementActive">Gerenciamento</a>
              }
            </nav>
          }
        </div>
      }
      <!-- User Section -->
      <div class="user-section" [ngClass]="{'ion-hide': isAdminContext}">
        <span
          class="user-info"
          id="user-trigger"
          role="button"
          aria-label="Menu do usuário"
          tabindex="0"
          (mouseenter)="userPopoverReference = 'trigger'"
          (click)="presentUserPopover($event)"
          (keyup.enter)="presentUserPopover($event)"
          >
          <ion-icon name="person-circle-outline" />
        </span>
        <ion-popover
          [isOpen]="userPopoverOpen"
          trigger="user-trigger"
          side="bottom"
          alignment="center"
          [showBackdrop]="false"
          [dismissOnSelect]="true"
          [arrow]="true"
          [event]="clickEvent"
          [reference]="userPopoverReference"
          mode="ios"
          triggerAction="hover"
          class="admin-popover user-popover"
          (didDismiss)="userPopoverOpen = false"
          >
          <ng-template>
            <div class="admin-submenu">
              @if (showManagerButton$ | async) {
                <div class="submenu-item section-divider" (click)="showSelectPayeeModal()">
                  <ion-icon name="swap-horizontal-outline" />
                  <span>Trocar beneficiário</span>
                </div>
              }
              @if (payeeService.signedInPayee$ | async) {
                <div class="submenu-item" (click)="navigateUser('payment-data')">
                  <ion-icon name="cash-outline" />
                  <span>Dados de Pagamento</span>
                </div>
                <div class="submenu-item" (click)="navigateUser('account')">
                  <ion-icon name="lock-closed-outline" />
                  <span>Senha e Conta</span>
                </div>
              }
              <div class="submenu-item" (click)="signOut()">
                <ion-icon name="log-out-outline" />
                <span>Sair</span>
              </div>
            </div>
          </ng-template>
        </ion-popover>
      </div>
    </div>
  </div>
</ion-toolbar>
</div>

@if (showForLg()) {
  <div
    class="header ion-no-border ion-hide-lg-down"
    >
    <ion-toolbar
      class="transparent"
      [ngClass]="{'bottom-rounded': showBackground()}"
      [color]="showBackground() ? 'primary' : ''"
      >
      @if (title) {
        <ion-title color="secondary" class="ion-text-center">
          {{ title }}
        </ion-title>
      }
      <ion-buttons slot="start" [ngClass]="{'with-background': !showBackground()}">
        <ion-back-button [color]="showBackground() ? 'secondary' : 'primary'"
          text=""
          defaultHref="/"
          class="big-back-button"
          icon="close"
         />
      </ion-buttons>
    </ion-toolbar>
  </div>
}